// src/lib/travelHealth/tier2/tier2ConfigRegistry.ts
//
// Lookup map only. No logic, no clinical values. Starts empty — no product
// configs are registered here. Individual product config files call
// registerTier2Config at module initialisation time to populate it.

import type { TravelHealthTier2Config } from "./tier2Config.types";
import type { PgdId } from "../pgds/pgdIds";

const registry = new Map<PgdId, TravelHealthTier2Config>();

export function registerTier2Config(config: TravelHealthTier2Config): void {
  registry.set(config.pgdId, config);
}

export function getTier2Config(
  pgdId: string,
): TravelHealthTier2Config | undefined {
  return registry.get(pgdId as PgdId);
}

export function getAllRegisteredPgdIds(): PgdId[] {
  return Array.from(registry.keys());
}
